// React
import { useState } from "react"

// Components
import { Card, DashboardFilter, HeaderMenu } from "components"
import {
  Efficiency,
  FinancialPosition,
  FinancialRatio,
  ProfitAndLost
} from "./components/Section"

// Types
import type { FillterType } from "./types"

// Third-Party Libraries
import moment from "moment"

export default function Dashboard() {
  // Hooks
  const [fill, setFill] = useState<FillterType>({
    type: "Date",
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
    month: moment().format("MM"),
    year: moment().format("YYYY"),
    quarter: moment().format("Q")
  })


  return (
    <section className="container my-5">
      <HeaderMenu title="ACCOUNT DASHBOARD" />

      <section className="mt-2">
        <div>

          <DashboardFilter
            onChangeFilter={(res) => {

              if (res.type === "Date" || res.type === "Month") {
                

                setFill({
                  ...fill,
                  type: res.type,
                  start_date: res.date_from,
                  end_date: res.date_end,
                  month: moment(res.date_from).format("MM"),
                  year: moment(res.date_from).format("YYYY"),
                  location_id: res.location_id
                })
              } else if (res.type === "Quarter") {

                setFill({
                  ...fill,
                  type: res.type,
                  month: moment(res.date_from).format("MM"),
                  year: moment(res.date_from).format("YYYY"),
                  location_id: res.location_id,
                  quarter: moment(res.date_from).format("Q"),
                  start_date: res.date_from,
                  end_date: res.date_end
                })
              } else if (res.type === "Year") {

                setFill({
                  ...fill,
                  type: res.type,
                  year: moment(res.date_from).format("YYYY"),
                  location_id: res.location_id
                })
              }
            }}
          />
      
          <Card>
            <Card.Body>
              <div className="mt-3 px-2 overflow-x-auto max-h-[calc(100vh-500px)]">
                {/* Profitablity section */}
                <div>
                  <ProfitAndLost
                    month={fill.month}
                    year={fill.year}
                    location_id={fill.location_id}
                  />

                </div>

                {/* Efficiency section */}
                <div className="mt-4">
                  <Efficiency
                    month={fill.month}
                    year={fill.year}
                    location_id={fill.location_id}
                  />
                </div>

                {/* Financial position and cash */}
                <div className="mt-4">
                  <FinancialPosition
                    month={fill.month}
                    year={fill.year}
                    location_id={fill.location_id}
                  />
                </div>

                {/* Financial ratio */}
                <div className="mt-4">
                  <FinancialRatio 
                    month={fill.month}
                    year={fill.year}
                    location_id={fill.location_id}
                   />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </section>
      {/* <section className="mt-2">
        <FooterMenu />
      </section> */}
    </section>
  )
}
